import {
  AuthorizationConsentModal,
  RemoveAccessModal,
  AuthorizationErrorModal,
} from './AuthorizationModalConsent';
import type { UseDependentConsentReturn } from './useDependentConsent';

type DependentConsentModalsProps = {
  consent: UseDependentConsentReturn;
};

// Renders the three dependent-consent modals wired to the shared consent flow.
export const DependentConsentModals: React.FC<DependentConsentModalsProps> = ({ consent }) => (
  <>
    <AuthorizationConsentModal
      isOpen={consent.showConsentModal}
      accessType={consent.consentAccessType}
      onClose={consent.handleConsentCancel}
      onConfirm={consent.handleConsentConfirm}
      showActionButtons={consent.showConsentActionButtons}
    />
    <RemoveAccessModal
      isOpen={consent.showRemoveAccessModal}
      accessType={consent.removeAccessType}
      onClose={consent.handleRemoveAccessCancel}
      onConfirm={consent.handleRemoveAccessConfirm}
    />
    <AuthorizationErrorModal
      isOpen={consent.showErrorModal}
      onClose={consent.closeErrorModal}
    />
  </>
);
